import leafletInit from '../theme/leaflet';

const { docReady } = window.phoenix.utils;

docReady(leafletInit);
